import axios from 'axios';
import { Dialog } from 'quasar';
import { TokenService } from 'src/services';
import { useAuthStore } from 'src/stores/auth-store';

const excludeUrl = ['/account/reset-password'];

function createDealerAxios(baseUrl: string) {
	let body: any = null;

	const dealerTokenAxios = axios.create({ baseURL: baseUrl });
	dealerTokenAxios.interceptors.request.use(config =>
		TokenService.checkDealerToken().then(token => {
			if (config.url!.indexOf('authentication') === -1) {
				body = config.data;
			}
			config.headers.Authorization = `Bearer ${token}`;
			return Promise.resolve(config);
		})
	);

	dealerTokenAxios.interceptors.response.use(
		res => res,
		err => {
			if (err && err.response && err.response.status !== 401) {
				if (err.response.status === 409) {
					useAuthStore().logout(true);
					Dialog.create({
						title: 'Banned',
						message: 'You have been banned from the system. Please contact support for more information.',
						class: 'tw-max-w-[90vw]'
					});
					return;
				}
				let additionalMsg = '';
				if (err.response.data) {
					additionalMsg = JSON.stringify(err.response.data, null, 4);
				}
			}

			throw err;
		}
	);

	return dealerTokenAxios;
}

function createClientAxios(baseUrl: string) {
	const clientTokenAxios = axios.create({ baseURL: baseUrl });

	let body: any = null;

	clientTokenAxios.interceptors.request.use(config =>
		TokenService.setAuthClientToken().then(token => {
			if (config.url!.indexOf('authentication') === -1) {
				body = config.data;
			}
			config.headers.Authorization = `Bearer ${token}`;
			return Promise.resolve(config);
		})
	);

	clientTokenAxios.interceptors.response.use(
		res => res,
		err => {
			if (err && err.response && err.response.status !== 401) {
				let additionalMsg = '';
				if (err.response.data) {
					additionalMsg = JSON.stringify(err.response.data, null, 4);
				}
			}
			throw err;
		}
	);

	return clientTokenAxios;
}

function createAxios(baseUrl: string) {
	const serviceAxios = axios.create({ baseURL: baseUrl });

	let body: any = null;

	serviceAxios.interceptors.request.use(config => {
		if (config.url!.indexOf('authentication') === -1) {
			body = config.data;
		}
		return Promise.resolve(config);
	});

	serviceAxios.interceptors.response.use(
		res => res,
		err => {
			if (err && err.response && err.response.status !== 401) {
				let additionalMsg = '';
				if (err.response.data) {
					additionalMsg = JSON.stringify(err.response.data, null, 4);
				}
			}
			throw err;
		}
	);

	return serviceAxios;
}

export { createAxios, createClientAxios, createDealerAxios };
